var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 29,
    viewBox: "0 0 53 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.598805 0.608404C0.788138 0.415548 1.01306 0.262537 1.26068 0.158137C1.50831 0.0537373 1.77377 0 2.04187 0C2.30996 0 2.57543 0.0537373 2.82305 0.158137C3.07067 0.262537 3.29559 0.415548 3.48493 0.608404L26.5005 23.9971L49.5161 0.608404C49.7057 0.41586 49.9306 0.263125 50.1782 0.158921C50.4258 0.0547175 50.6912 0.00108426 50.9592 0.00108426C51.2272 0.00108426 51.4926 0.0547175 51.7402 0.158921C51.9878 0.263125 52.2128 0.41586 52.4023 0.608404C52.5918 0.800947 52.7421 1.02953 52.8447 1.2811C52.9472 1.53267 53 1.8023 53 2.0746C53 2.3469 52.9472 2.61653 52.8447 2.8681C52.7421 3.11967 52.5918 3.34825 52.4023 3.5408L27.9436 28.3916C27.7543 28.5845 27.5293 28.7375 27.2817 28.8419C27.0341 28.9463 26.7686 29 26.5005 29C26.2324 29 25.967 28.9463 25.7194 28.8419C25.4717 28.7375 25.2468 28.5845 25.0575 28.3916L0.598805 3.5408C0.408992 3.34843 0.258397 3.1199 0.155644 2.86831C0.0528913 2.61672 0 2.347 0 2.0746C0 1.80221 0.0528913 1.53249 0.155644 1.28089C0.258397 1.0293 0.408992 0.800772 0.598805 0.608404Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.4c2d9313b3437735122cef8bd5f44763.svg";
export { ForwardRef as ReactComponent };